const parse = (response) => {
  if (!response.ok) {
    return response.json().then((data) => {
      throw new Error(data.error || 'Request failed');
    });
  }

  return response.json();
};

// site_ids is repeated rather than joined, because Rails parses site_ids[] into an array and a
// comma-joined string would arrive as a single meaningless id.
export const buildReportableEventQuery = ({
  siteIds,
  dateRange,
  reportType,
  reviewStatus,
  sortColumn,
  sortDirection,
}) => {
  const query = new URLSearchParams();

  (siteIds || []).forEach((siteId) => query.append('site_ids[]', siteId));

  if (dateRange) {
    query.set('date_range', dateRange);
  }

  if (reportType) {
    query.set('report_type', reportType);
  }

  if (reviewStatus) {
    query.set('review_status', reviewStatus);
  }

  if (sortColumn) {
    query.set('sort_column', sortColumn);
  }

  if (sortDirection) {
    query.set('sort_direction', sortDirection);
  }

  return query.toString();
};

export const getReportableEvents = (filters = {}, { signal } = {}) =>
  fetch(`/api/v2/clinical/reportable_events?${buildReportableEventQuery(filters)}`, {
    headers: { 'Content-Type': 'application/json' },
    signal,
  }).then(parse);

export const getReportableEvent = (id) =>
  fetch(`/api/v2/clinical/reportable_events/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  }).then(parse);

// The filename is set by the server so the exported file matches the name in the ticket without
// the browser having to work out what today's date is.
export const exportReportableEvents = (filters = {}) =>
  fetch(`/api/v2/clinical/reportable_events/export.csv?${buildReportableEventQuery(filters)}`, {
    headers: { Accept: 'text/csv' },
  }).then((response) => {
    if (!response.ok) {
      throw new Error('Export failed');
    }

    return response.blob().then((blob) => ({
      blob: blob,
      filename: response.headers.get('X-Filename') || 'Reportable_Events.csv',
    }));
  });

export const markReportableEventUnread = (id) =>
  fetch(`/api/v2/clinical/reportable_events/${id}/read`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'DELETE',
  }).then(parse);

export const markReportableEventReviewed = (id) =>
  fetch(`/api/v2/clinical/reportable_events/${id}/review`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  }).then(parse);

export const markReportableEventUnreviewed = (id) =>
  fetch(`/api/v2/clinical/reportable_events/${id}/review`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'DELETE',
  }).then(parse);

export const getReportableEventCounts = () =>
  fetch('/api/v2/clinical/reportable_events/counts', {
    headers: { 'Content-Type': 'application/json' },
  }).then(parse);
